import { PromoCodeType } from 'v2/constants';
import { GroupPromoCodeForm, PromoCodeModel, UniquePromoCodeForm } from 'v2/types/PromoCodeModel';

export type SinglePromoCodeForm = Omit<PromoCodeModel, 'id' | 'createdBy'>;

export const singlePromoCodeFormInitialValues: SinglePromoCodeForm = {
  groupName: '',
  name: '',
  activationNumber: 0,
  value: '',
  type: PromoCodeType.BALANCE,
};

export const uniquePromoCodesFormInitialValues: UniquePromoCodeForm = {
  groupName: '',
  value: '',
  type: PromoCodeType.BALANCE,
  promocodesCount: 0,
};

export const groupPromoCodesFormInitialValues: GroupPromoCodeForm = {
  groupName: '',
  value: '',
  type: PromoCodeType.BALANCE,
  activationNumber: 0,
  promocodesNames: [],
};
